/**
 * Persisted editor/preview UI chrome theme (sun/moon toggle).
 * No valid localStorage → follow prefers-color-scheme (browser/OS).
 */

export const VIEWPORT_UI_THEME_STORAGE_KEY = "mbx-viewport-ui-theme";

/** @returns {"dark" | "light" | null} */
export function getPersistedViewportUiTheme() {
  if (typeof window === "undefined") return null;
  try {
    const v = localStorage.getItem(VIEWPORT_UI_THEME_STORAGE_KEY);
    if (v === "dark" || v === "light") return v;
  } catch {
    /* ignore */
  }
  return null;
}

/** Browser / OS preference when user has not saved a choice. */
export function getSystemPreferredUiTheme() {
  if (typeof window === "undefined") return "light";
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  } catch {
    return "light";
  }
}

/** Persisted choice wins; otherwise prefers-color-scheme. */
export function getInitialViewportUiTheme() {
  return getPersistedViewportUiTheme() ?? getSystemPreferredUiTheme();
}

/** @param {"dark" | "light"} mode */
export function persistViewportUiTheme(mode) {
  const m = mode === "dark" ? "dark" : "light";
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(VIEWPORT_UI_THEME_STORAGE_KEY, m);
  } catch {
    /* ignore */
  }
}

/** Sync Mantine CSS variables (see style.css [data-mantine-color-scheme]). */
export function applyDocumentColorScheme(mode) {
  const m = mode === "dark" ? "dark" : "light";
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-mantine-color-scheme", m);
}
